import { rem } from 'polished'
import styled from 'styled-components'

const TripPageContainer = styled.div`
  padding: ${rem(20)} 0;

  @media print {
    a {
      text-decoration: none;
    }

    a[href]::after {
      content: none !important;
    }
  }
`

export default TripPageContainer
